export enum IonicColorEnum {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LIGHT = 'light',
  SUCCESS = 'success',
  DANGER = 'danger'
}
